import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 5.866a.99.99 0 0 1 1 .977v4.888a.99.99 0 0 1-1 .978.99.99 0 0 1-1-.978V6.843a.99.99 0 0 1 1-.977m3.5 3.421a.99.99 0 0 1-1 .978h-5a.99.99 0 0 1-1-.978.99.99 0 0 1 1-.977h5a.99.99 0 0 1 1 .977m5.642-7.448C18.991.68 17.456 0 15.826 0a6.3 6.3 0 0 0-4.412 1.84l-.384.386-.384-.387A6.13 6.13 0 0 0 6.234 0c-1.63 0-3.165.678-4.316 1.84C.768 3 0 4.646 0 6.291s.671 3.29 1.822 4.452l8.44 8.518c.192.193.384.29.672.29s.48-.097.671-.29l8.44-8.518c2.59-2.42 2.59-6.484.097-8.904m-1.343 7.55-7.77 7.84-7.768-7.84c-1.726-1.742-1.726-4.452 0-6.195.767-.87 1.918-1.258 2.973-1.258 1.151 0 2.206.387 3.07 1.258l1.054 1.065a.92.92 0 0 0 1.343 0l.96-1.065c.863-.774 1.918-1.258 3.165-1.258 1.15 0 2.206.484 3.069 1.258.767.871 1.247 1.936 1.247 3.098s-.48 2.226-1.343 3.097"
    }, null, -1)
  ]))]))
}
export default { render: render }